<form class="field-dialog__content__scroll p-24" name="form" fusePerfectScrollbar>
  <div *ngIf="!quotations.length" fxLayout="column" fxLayoutAlign="center center">
    <p fxFlex="100" fxLayout="row">
      <mat-icon class="no-results-icon">attach_money</mat-icon>
    </p>
    <div fxFlex="100" fxLayout="row">
      <span class="h3">{{ 'MAINTENANCES.TABS.QUOTATIONS.WITHOUT_QUOTATIONS' | translate }}</span>
    </div>
  </div>

  <ng-container *ngIf="quotations.length">
    <div *ngFor="let quotation of quotations">
      <div class="quotations" fxLayout="column" fxLayoutAlign="start center" fxFlex="100">
        <div class="quotations__header" fxLayout="row" fxLayoutAlign="start center">
          <div class="quotations__header wrapper">
            <img class="wrapper__icon" src="assets/images/icons/quotation.svg" />
            <span class="wrapper__name">{{ quotation.name }} </span>
            <button
              class="wrapper__button"
              mat-icon-button
              matTooltip="{{ 'MAINTENANCES.TABS.QUOTATIONS.VIEW_QUOTATION' | translate }}"
              (click)="openDialog(quotation.id)"
            >
              <i class="angularjs-fuse-icon icon-eye"></i>
            </button>
          </div>
        </div>
        <div class="quotations__body card" fxLayout="row">
          <div class="w-25" fxLayout="column" fxLayoutAlign="start start">
            <b>{{ quotation.identifier }}</b>
            <div>
              <p>{{ 'MAINTENANCES.TABS.QUOTATIONS.SITUATION' | translate }}</p>
              <p class="{{ quotation.status }}-fg">
                {{ quotation.status | enum: 'quotation_status' }}
              </p>
            </div>
          </div>
          <div class="w-25" fxLayout="column" fxLayoutAlign="start start">
            <b>{{
              'MAINTENANCES.TABS.QUOTATIONS.PRODUCTS_COUNT' | translate: { productsCount: quotation.productsCount }
            }}</b>
            <p>
              {{
                'MAINTENANCES.TABS.QUOTATIONS.PRODUCTS_TOTAL_VALUE'
                  | translate: { productsTotal: quotation.productsValueTotal | currency: 'BRL' }
              }}
            </p>
          </div>
          <div class="w-25" fxLayout="column" fxLayoutAlign="start start">
            <b>{{
              'MAINTENANCES.TABS.QUOTATIONS.SERVICES_COUNT' | translate: { servicesCount: quotation.servicesCount }
            }}</b>
            <p>
              {{
                'MAINTENANCES.TABS.QUOTATIONS.SERVICES_TOTAL_VALUE'
                  | translate: { servicesTotal: quotation.servicesValueTotal | currency: 'BRL' }
              }}
            </p>
          </div>
          <div class="quotations__body total-values w-25">
            <p class="m-5">
              {{
                'MAINTENANCES.TABS.QUOTATIONS.SUBTOTAL' | translate: { subtotal: quotation.subTotal | currency: 'BRL' }
              }}
            </p>
            <p class="m-5">
              {{
                'MAINTENANCES.TABS.QUOTATIONS.DISCOUNT'
                  | translate: { discount: quotation.discount?.total | currency: 'BRL' }
              }}
            </p>
            <p class="m-5">
              {{ 'MAINTENANCES.TABS.QUOTATIONS.TOTAL' | translate: { total: quotation.total | currency: 'BRL' } }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</form>
